<template>
    <div class="vertical-stack">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

.vertical-stack {
    @include Pathfinder.VerticalStack;
}
</style>
